import { Paper, Stack, Typography } from '@mui/material';
import { PrescriptionsGrid } from './PrescriptionsGrid';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

export const PrevPrescriptions = () => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  return (
    <Paper elevation={0} sx={{ bgcolor: 'transparent', maxWidth: '1125px' }}>
      <Stack>
        <Typography variant='h5' mt={4} sx={{ mt: 4, mb: 3 }}>
          {dictionary.prescriptionsStatus}
        </Typography>
        <PrescriptionsGrid />
      </Stack>
    </Paper>
  );
};
